import { render } from "./AddCustomer.vue?vue&type=template&id=7c58a1f9&scoped=true"
import script from "./AddCustomer.vue?vue&type=script&lang=js"
export * from "./AddCustomer.vue?vue&type=script&lang=js"

import "./AddCustomer.vue?vue&type=style&index=0&id=7c58a1f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c58a1f9"]])

export default __exports__